@if (meta.isLoading()) {
  <div class="flex justify-center items-center h-64">
    <app-loading [noWhitespace]="true"></app-loading>
  </div>
} @else if (meta.error()) {
  <div class="flex justify-center items-center h-64">
    <div class="text-red-500">{{ { key: 'errorLoading' } | i18n }}</div>
  </div>
} @else {
  @if ((meta.value()?.files?.[fileType()]?.length || 0) > 0) {
    <p class="mt-4">{{ { key: 'alreadyUploadedFiles' } | i18n }}</p>
    <ul class="list-disc">
      @for (file of meta.value()?.files?.[fileType()]; track file.attachmentId) {
        <li class="ml-6">{{ file.fileName }}</li>
      }
    </ul>
  }
  <div class="mt-8 cursor-pointer">
    <label (drop)="uploadFile($event)" (dragover)="dragOver($event)" (dragleave)="dragLeave($event)">
      <div class="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10 bg-opacity-25 cursor-pointer">
        {{ { key: 'dragOrClickToUpload' } | i18n }}
      </div>
      <input class="sr-only" type="file" (change)="uploadFile($event)" />
    </label>
  </div>
}
